import { createSlice, createEntityAdapter } from '@reduxjs/toolkit'

import { getTechs } from './api'
import type { CoreEmployeeModel } from './typings'
import type { StoreData } from '../reducers/typings'

const techEntityAdapter = createEntityAdapter<CoreEmployeeModel>()

export const initialState = techEntityAdapter.getInitialState({
  count: 0,
  skip: 0,
  take: 0,
})

const techSlice = createSlice({
  name: 'techs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTechs.fulfilled, (state, { payload }) => {
      const { items, count, skip, take } = payload

      state.count = count
      state.skip = skip
      state.take = take

      techEntityAdapter.setAll(state, items ?? [])
    })
  },
})

export default techSlice.reducer

export const { selectAll: selectAllTechs } =
  techEntityAdapter.getSelectors<StoreData>((state) => state.techs)
